import React, { useRef, useState } from 'react';
import { useDialogTouch } from './use-dialog-touch';
import { isInsideClick } from './dialog.helpers';
import { Anchor, Button, CloseButton } from '../../buttons';
import { FilterButton } from './filter-button/filter-button';
import { colourString } from '../../../library';
import styles from './filters.module.css';
export function Filters(props) {
    var children = props.children;
    var dialogRef = useRef(null);
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    var _b = useState(false), active = _b[0], setActive = _b[1];
    useDialogTouch(dialogRef, open, closeDialog);
    function openDialog() {
        setOpen(true);
        document.body.style.height = '100vh';
        document.body.style.overflowY = 'hidden';
    }
    function closeDialog() {
        var dialog = dialogRef.current;
        if (!dialog)
            return;
        dialog.classList.add(styles.close); // run animation here
        setOpen(false);
        setTimeout(function () {
            dialog.classList.remove(styles.close);
            document.body.style.height = 'auto';
            document.body.style.overflowY = 'auto';
            dialog.close();
        }, 500 // needs to match animation time, 'animationend' EventListener didn't work
        );
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(FilterButton, { label: "Filters", active: active, onClick: openDialog }),
        React.createElement("dialog", { className: styles.filtersDialog, ref: dialogRef, onClick: function (event) {
                if (isInsideClick(dialogRef, event))
                    return;
                closeDialog();
            } },
            React.createElement(CloseButton, { onClick: closeDialog }),
            React.createElement("header", { className: styles.filtersHeader },
                React.createElement("h5", { className: "heading5", style: { color: colourString('accent-2') } }, "Filter by")),
            React.createElement("section", { className: styles.filtersBody }, children),
            React.createElement("footer", { className: styles.filtersFooter },
                React.createElement(Anchor, { onClick: function () {
                        props.onClickClear();
                        setActive(false);
                        closeDialog();
                    } }, "Clear Filters"),
                React.createElement(Button, { type: "button", arrow: false, filled: true, onClick: function () {
                        props.onClickApply();
                        setActive(true);
                        closeDialog();
                    } }, "Apply Filters")))));
}
export default Filters;
